import { useEffect, useRef, useState } from 'react';
import { throttle } from 'lodash';
import { useTwilioAppState } from '../state/';

export default function useShowControls() {
    const [showControls, setShowControls] = useState(true);
    const timeoutRef = useRef(0);
    const { _isMounted } = useTwilioAppState();

    useEffect(() => {
        const handleUserActivity = throttle(() => {        
            clearTimeout(timeoutRef.current);
            const timeoutId = window.setTimeout(() => {
                if(_isMounted && _isMounted.current === true)
                    setShowControls(false);
                window.removeEventListener('mousemove', handleUserActivity);
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                }
            }, 3000);
            timeoutRef.current = timeoutId;
        }, 500);

        handleUserActivity();

        window.addEventListener('mousemove', handleUserActivity);
        return () => {
            window.removeEventListener('mousemove', handleUserActivity);
            if (timeoutRef.current)
                clearTimeout(timeoutRef.current);

        };
       
    }, [_isMounted]);

    return [showControls, setShowControls];
}